import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/userTaskActions';

const userTaskActions = {

    assignUserToTask(taskID, user, quota) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());
            request
                .post(env.tashi + '/tasks/' + taskID + "/assign")
                .withCredentials()
                .accept('application/json')
                .send({
                    user: user,
                    quota: quota
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.assignUserToTask({ status: "failure", data: err }));
                        return;
                    }

                    //parse newly created UserTask from the server response and add it to newState
                    let data = JSON.parse(res.text);
                    if (res.ok) {
                        dispatch(actions.assignUserToTask({ status: "success", data: data }));
                    } else {
                        dispatch(actions.assignUserToTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    create(userTask) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .post(env.tashi + '/userTasks')
                .withCredentials()
                .accept('application/json')
                .send(userTask)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createUserTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.createUserTask({ status: "success", data: userTask }));
                    } else {
                        dispatch(actions.createUserTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    loadById(userTaskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .get(env.tashi + '/userTasks/' + userTaskID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUserTaskByID({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    dispatch(actions.loadUserTaskByID({ status: "success", data: data }));
                });
        };
    },

    loadByTask(taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .get(env.tashi + '/userTasks/search/findByTask')
                .query({
                    task: taskID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUserTasksByTask({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.userTasks : null;

                    if (data) {
                        dispatch(actions.loadUserTasksByTask({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadUserTasksByTask({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadByUser(userID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .get(env.tashi + '/userTasks/search/findByUser')
                .query({
                    user: userID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadUserTasksByUser({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.userTasks : [];

                    if (data) {
                        dispatch(actions.loadUserTasksByUser({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadUserTasksByUser({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadQuotaHistoryByUserTask(userTaskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .get(env.tashi + '/userTasks/quotaHistory')
                .query({
                    userTaskId: userTaskID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadQuotaHistoryByUserTask({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadQuotaHistoryByUserTask({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadQuotaHistoryByUserTask({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmLoadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .get(env.tashi + '/userTasks/search/pm_findAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadAllUserTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.userTasks;

                    if (data) {
                        dispatch(actions.pmLoadAllUserTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadAllUserTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    unassignUserFromTask(userTaskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());
            request
                .post(env.tashi + '/userTasks/' + userTaskID + '/unassign')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.unassignUserFromTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.unassignUserFromTask({ status: "success", data: userTaskID }));
                    } else {
                        dispatch(actions.unassignUserFromTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    updateAlias(userTaskID, alias) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .post(env.tashi + '/userTasks/' + userTaskID + '/alias')
                .withCredentials()
                .accept('application/json')
                .send({
                    alias: alias
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.updateUserTaskAlias({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.updateUserTaskAlias({ status: "success", data: userTaskID }));
                    } else {
                        dispatch(actions.updateUserTaskAlias({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    updateColor(userTask) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .patch(env.tashi + '/userTasks/' + userTask.id + "/color")
                .withCredentials()
                .accept('application/json')
                .send(userTask)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.updateUserTaskColor({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.updateUserTaskColor({ status: "success", data: userTask }));
                    } else {
                        dispatch(actions.updateUserTaskColor({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    updateFavorite(userTask) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());

            request
                .patch(env.tashi + '/userTasks/' + userTask.id + "/favorite")
                .withCredentials()
                .accept('application/json')
                .send(userTask)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.updateUserTaskFavorite({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.updateUserTaskFavorite({ status: "success", data: userTask }));
                    } else {
                        dispatch(actions.updateUserTaskFavorite({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    updateQuota(userTaskID, userTask) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForUserTaskState());
            request
                .post(env.tashi + '/userTasks/' + userTaskID + '/quota')
                .withCredentials()
                .accept('application/json')
                .send(userTask)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.updateUserTaskQuota({ status: "failure", data: err }));
                        return;
                    }
                    if (res.ok) {
                        dispatch(actions.updateUserTaskQuota({ status: "success", data: userTaskID }));
                    } else {
                        dispatch(actions.updateUserTaskQuota({ status: "failure", data: res.status }));
                    }
                });
        };
    }

};

export default userTaskActions;


/** WEBPACK FOOTER **
 ** ./src/app/actions/userTaskActionCreators.js
 **/